<template>
  <section>
    <nav class="level">
      <div class="level-left">
        <p class="is-size-4 has-text-weight-medium has-text-danger">
          若旅行團價錢隱藏，就只會觸發線上諮詢。
        </p>
      </div>
      <div class="level-right">
        <p class="level-item">
          <a class="button is-primary" @click="onAdd">
            <b-icon icon="plus"></b-icon>
            <span>{{ $t('attributes.add') + $t('attributes.situation') }}</span>
          </a>
        </p>
      </div>
    </nav>

    <b-table
      :data="events"
      :loading="loading"
      bordered
      :mobile-cards="false"
      style="max-width:650px; margin:0 auto;"
    >
      <b-table-column
        field="sort"
        :label="$t('attributes.sort')"
        width="75"
        numeric
        centered
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>

      <b-table-column
        field="status"
        :label="$t('attributes.activation_status')"
        width="75"
        centered
        v-slot="props"
      >
        <b-tag
          :type="props.row.status ? 'is-info' : 'is-danger'"
          size="is-medium"
        >
          {{ activeStatus(props.row.status) }}
        </b-tag>
      </b-table-column>

      <b-table-column
        field="action"
        :label="$t('attributes.situation_action')"
        width="120"
        centered
        v-slot="props"
      >
        {{ areaActionName(props.row.action) }}
      </b-table-column>

      <b-table-column
        field="Demo"
        :label="$t('attributes.preview')"
        centered
        v-slot="props"
      >
        <p
          :class="
            props.row.deep_style ? 'situation_demo deep' : 'situation_demo'
          "
        >
          <span v-html="props.row.name"></span>
        </p>
      </b-table-column>

      <b-table-column :width="100" label="功能" centered v-slot="props">
        <b-button
          type="is-primary"
          size="is-small"
          outlined
          @click.prevent="onModify(props.row)"
        >
          {{ $t('attributes.modify') }}
        </b-button>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div v-if="!loading" class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
          </div>
        </section>
      </template>
    </b-table>

    <b-modal
      :active.sync="isFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <event-form :event="selectedEvent" :area="area" @send="onSend" />
    </b-modal>
  </section>
</template>

<script>
import { AREA_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import EventForm from './EventForm'

export default {
  name: 'EventList',
  components: { EventForm },

  props: {
    area: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      sending: false,
      code: this.area.code,
      events: [],

      isFormModalActive: false,
      selectedEvent: null
    }
  },
  watch: {
    area(newArea) {
      this.code = newArea.code
      this.isFormModalActive = false
      this.selectedEvent = null
      this.loadEventsAsync(newArea.code)
    }
  },
  mounted() {
    this.loadEventsAsync(this.area.code)
  },
  methods: {
    async loadEventsAsync(code) {
      try {
        this.loading = true
        const api = `${AREA_API}/${code}/events`
        const res = await this.axios.get(api)
        this.events = res.data.data
      } catch (e) {
        this.events = []

        notifyService.fetch_error('event', e)
      } finally {
        this.loading = false
      }
    },
    onAdd() {
      this.selectedEvent = {
        id: null,
        name: '',
        sort: 1,
        status: true,
        action: 'A',
        picture: null
      }
      this.isFormModalActive = true
    },
    onModify(item) {
      this.selectedEvent = item
      this.isFormModalActive = true
    },
    onSend(item) {
      if (item.id == null) {
        this.create(item)
      } else {
        this.update(item)
      }
    },
    async create(item) {
      const api = `${AREA_API}/${this.code}/events`

      try {
        this.sending = true
        const res = await this.axios.post(api, item)
        const _item = res.data.data

        const events = [...this.events, _item]
        this.events = events.sort((t1, t2) => t1.sort - t2.sort)

        this.isFormModalActive = false
        notifyService.success(this.$t('attributes.add_succeed'))
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    },
    async update(item) {
      const api = `${AREA_API}/${this.code}/events/${item.id}`

      try {
        this.sending = true
        const res = await this.axios.put(api, item)
        const _item = res.data.data

        const idx = this.events.findIndex(s => s.id === _item.id)
        const events = [...this.events]
        events[idx] = _item
        this.events = events.sort((t1, t2) => t1.sort - t2.sort)

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.b-table {
  td {
    vertical-align: middle;

    .situation_demo {
      display: inline-block;
      color: #af7f54;
      border: 1px solid #af7f54;
      padding: 0em 0.2em 0.2em 0.2em;
      width: 110px;
      text-align: center;
    }
    .situation_demo.deep {
      color: #fff;
      background-color: #af7f54;
    }
  }
}
</style>
